import { useMemo } from "react";
import { LayoutContext } from ".";
import { Layout } from "../../types/layout";

export interface LayoutProps {
  layout?: Layout;
  children?: React.ReactNode;
}

export const LayoutProvider = ({
  children,
  layout = Layout.desktop,
}: LayoutProps): JSX.Element => {
  const value = useMemo(
    () => ({
      layout,
      isMobile: layout === Layout.mobile,
    }),
    [layout]
  );

  return (
    <LayoutContext.Provider value={value}>{children}</LayoutContext.Provider>
  );
};
